<template>
  <v-app>
    <template v-if="adminFlag && userStatus">
      <AdminMenu />
    </template>
    <template v-if="!adminFlag && userStatus">
      <v-app-bar app>
        <v-toolbar-title>
          <span>{{ storename }}</span>
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-app-bar-nav-icon @click.stop="drawer = !drawer"></v-app-bar-nav-icon>
      </v-app-bar>
      <UserMenu v-model="drawer" />
    </template>
    <template v-if="guestFlag">
      <v-app-bar app>
        <v-toolbar-title>
          <span>{{ storename }}</span>
        </v-toolbar-title>
        <v-spacer></v-spacer>
      </v-app-bar>
    </template>
    <v-content>
      <router-view></router-view>
    </v-content>
  </v-app>
</template>

<script>
import AdminMenu from "@/components/AdminMenu";
import UserMenu from "@/components/UserMenu";

export default {
  name: "App",
  components: {
    AdminMenu,
    UserMenu
  },
  data: function() {
    return {
      drawer: false
    };
  },
  beforeCreate: function() {
    this.storename = process.env.VUE_APP_STORE_NAME || "Crossfit Reservation";
  },
  computed: {
    userStatus() {
      return this.$store.getters[
        "loginStore/loginInfo/loginInfoStore/isSignedIn"
      ];
    },
    adminFlag() {
      return this.$store.getters["loginStore/loginInfo/loginInfoStore/isAdmin"];
    },
    guestFlag() {
      return this.$store.getters["loginStore/loginInfo/loginInfoStore/isGuest"];
    }
  }
};
</script>
